module.exports = __webpack_public_path__ + "static/howto3.a87a4a66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/howto3.svg
// module id = 369
// module chunks = 221374088121123